import { Tabs, TabsProps } from 'antd'
import { translate } from '../../../core'
// Temporarily unused — re-enable together with the 'upload_one' tab below.
// import { ItemFormUpdateImages } from './ItemFormUpdateImages'
import { MassUpload } from './MassUpload'

export const ItemUploadImages = () => {
  const items: TabsProps['items'] = [
    // Temporarily hidden until future review/redesign. Do not delete — re-enable
    // by uncommenting this tab and restoring defaultActiveKey='upload_one'.
    // {
    //   label: translate('upload_one'),
    //   key: 'upload_one',
    //   children: <ItemFormUpdateImages/>,
    // },
    {
      label: translate('mass_upload'),
      key: 'mass_upload',
      children: <MassUpload/>
    },
  ]

  return (
    <Tabs
      defaultActiveKey='mass_upload'
      items={items}
    />
  )
}